const BOX_BORDER = "solid 1px #dbdbdb";
const BORDER_RADIUS = "3PX";

export default {
  backgroundColor: "#FAFAFA",
  textColor: "#000000",
  whiteColor: "#FFFFFF",
  blackColor: "#262626",
  greyColor: "#999999",
  darkGreyColor: "#999",
  redColor: "#fb3958",
  blueColor: "#3897f0",
  navyColor: "#003569",
  borderRadius: "3px",
  uiColorOrange: "#f7a400",
  uiColorBlue: "#3a9efd",
  uiColorPupple: "#3e4491",
  uiColorDeepPupple: "#292a73",
  uiColorNavy: "#1a1b4b",
  boxBorder: "solid 1px #dbdbdb",
  whiteBox: `border: ${BOX_BORDER};
             border-radius: ${BORDER_RADIUS}; 
            background-color: white;
            `
};
